import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { useEramanRegister } from "../Contents.hook";
import { fields } from "../constants";

export const Registration = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const { data: editData, error, isLoading: drilldownLoading, isError, refetch: refetchEditData } = useEramanRegister();

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    } else {
      refetchEditData();
    }
  }, [query.get("id")]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      signUp: decodeHTML(dataById ? dataById.payload.signUp : editData ? editData?.[0]?.signUp : ""),
      signUpDescription: decodeHTML(
        dataById ? dataById.payload.signUpDescription : editData ? editData?.[0].signUpDescription : ""
      ),
      username: decodeHTML(dataById ? dataById.payload.username : editData ? editData?.[0]?.username : ""),
      title: decodeHTML(dataById ? dataById.payload.title : editData ? editData?.[0]?.title : ""),
      icAnndPassport: decodeHTML(
        dataById ? dataById.payload.icAnndPassport : editData ? editData?.[0]?.icAnndPassport : ""
      ),
      nationality: decodeHTML(dataById ? dataById.payload.nationality : editData ? editData?.[0]?.nationality : ""),
      field_nric_data_field: decodeHTML(
        dataById ? dataById.payload.field_nric_data_field : editData ? editData?.[0]?.field_nric_data_field : ""
      ),
      passportNumber: decodeHTML(
        dataById ? dataById.payload.passportNumber : editData ? editData?.[0]?.passportNumber : ""
      ),
      mobileNumber: decodeHTML(dataById ? dataById.payload.mobileNumber : editData ? editData?.[0]?.mobileNumber : ""),
      emailAddress: decodeHTML(dataById ? dataById.payload.emailAddress : editData ? editData?.[0]?.emailAddress : ""),
      agree: decodeHTML(dataById ? dataById.payload.agree : editData ? editData?.[0]?.agree : ""),
      agreeEmail: decodeHTML(dataById ? dataById.payload.agreeEmail : editData ? editData?.[0]?.agreeEmail : ""),
      agreeSms: decodeHTML(dataById ? dataById.payload.agreeSms : editData ? editData?.[0]?.agreeSms : ""),
      password: decodeHTML(dataById ? dataById.payload.password : editData ? editData?.[0]?.password : ""),
      confirmPassword: decodeHTML(
        dataById ? dataById.payload.confirmPassword : editData ? editData?.[0]?.confirmPassword : ""
      ),
      passwordCondition: decodeHTML(
        dataById ? dataById.payload.passwordCondition : editData ? editData?.[0]?.passwordCondition : ""
      ),
      termsAndConditions: decodeHTML(
        dataById ? dataById.payload.termsAndConditions : editData ? editData?.[0]?.termsAndConditions : ""
      ),
      asterisktext: decodeHTML(dataById ? dataById.payload.asterisktext : editData ? editData?.[0]?.asterisktext : ""),
      register: decodeHTML(dataById ? dataById.payload.register : editData ? editData?.[0]?.register : ""),
      field_eraman_user_text: decodeHTML(
        dataById ? dataById.payload.field_eraman_user_text : editData ? editData?.[0]?.field_eraman_user_text : ""
      ),
      field_login_text_for_register: decodeHTML(
        dataById
          ? dataById.payload.field_login_text_for_register
          : editData
            ? editData?.[0]?.field_login_text_for_register
            : ""
      ),

      field_login_cover: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_eye_icon.png",
              status: "done",
              url: dataById?.payload?.field_login_cover,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_eye_icon.png",
              status: "done",
              url: editData?.[0]?.field_login_cover,
            },
          ]),
    },
    fields: fields.eramanRegistration,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = [
      "field_login_cover",
      "field_whiteheart_image",
      "field_redheart_image",
      "field_awardscover_image",
      "field_elogo_image",
      "field_ecard_image",
      "field_logo_new_image",
      "field_empty_wishlist_image",
      "field_download_image",
      "field_star_rate_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else {
          data[key] = ""; // fallback in case of invalid field
        }
      } catch (error) {
        console.error("Image processing failed for:", key, error);
      }
    }

    // let descKeys: any = [
    //   "signUpDescription",
    //   "passwordCondition",
    //   "termsAndConditions",
    // ];
    // for (const key of descKeys) {
    //   try {
    //     data[key] = {
    //       value: data[key] || "",
    //       format: "full_html",
    //     };
    //   } catch (error) { }
    // }

    const payload = {
      action: action,
      method: method,
      module: "Contents",
      subModule: `eramanRegistration`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.[0]?.id || dataById?.payload?.id }),
        ...data,
        published: true,
      },
      status: status,
    };

    console.log(payload, "test payload");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${eramanHost}/api/signup-for-membership-crud-api/${editData?.[0]?.id || dataById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </>
  );
};
